const model = {
    name: 'Content',
    properties: {
        fields: { type: 'array' }, // TODO: non-empty
    },
};
export default model;
